




























import { CreateElement, VNode } from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwStatusInfo } from '../sw-status-info';
import { SwButton } from '../sw-button';
import { SwActionBar, SwActionBarItem } from '../sw-action-bar';
import { StatusName, VueRenderFunction } from '../common-types';
import { ConfirmButton } from './types';
import { i18nService } from '../i18n-service';

const cssPrefix = 'sw-confirm-modal';

const i18nPathPrefix = 'libShared.SwConfirmModal';

/**
 * @event answer `(buttonKey: string)`
 * @event ready-to-destroy
 */
@Component({
  components: {
    SwStatusInfo,
    SwActionBar,
    SwActionBarItem,
    SwButton,
  },
})
export default class SwConfirmModal extends SwExtendedVue {
  @Prop({ type: Boolean, required: true })
  dialogVisible: boolean;

  @Prop({ type: String, required: true })
  status: StatusName;

  @Prop({ type: [String, Boolean], default: false })
  title: string | boolean;

  @Prop({ type: [String, Array, Function], required: true })
  message: string | string[] | VueRenderFunction;

  @Prop({
    type: Array,
    default(): ConfirmButton[] {
      return [
        { key: 'cancel', name: String(i18nService.i18n.t(`${i18nPathPrefix}.cancel`)) },
        { key: 'ok', name: String(i18nService.i18n.t(`${i18nPathPrefix}.ok`)), isDefault: true },
      ];
    },
  })
  buttons: ConfirmButton[];

  cssPrefix = cssPrefix;

  private i18PathValue(val: string) {
    return String(this.$t(`modules.generals[${val}]`));
  }

  private onClickButton(button: ConfirmButton) {
    this.$emit('answer', button.key);
  }

  private onAfterLeave() {
    this.$emit('ready-to-destroy');
  }

  private render(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div class={[`${this.cssPrefix}`, 'sw-typo-default']}>
        <transition name="sw-fade" appear on-after-leave={this.onAfterLeave}>
        {
          this.dialogVisible ? (
            <div class={[`${this.cssPrefix}__dialog`]}>
              <sw-status-info
                props-name={this.status}
                props-with-title={!!this.title ? this.title : false}
                props-closable={false}
                props-message={ typeof this.message === 'function' ? undefined : this.message }
              >{typeof this.message === 'function' ? this.message(h) : undefined}</sw-status-info>
              <div class={[`${this.cssPrefix}__footer`, 'sw-flexbox', 'sw-flexbox--end-justify']}>
                <sw-action-bar>
                {
                  this.buttons.map<VNode>(button => (
                    <sw-action-bar-item key={button.key}>
                      <sw-button
                        props-as-default={button.isDefault === true}
                        nativeOn-click={() => { this.onClickButton(button); }}
                      >{ button.name }</sw-button>
                    </sw-action-bar-item>
                  ) as VNode)
                }
                </sw-action-bar>
              </div>
            </div>
          ) : null
        }
        </transition>
      </div>
    ) as VNode;
  }
}
